import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getOnboardingSpecialties: [],
  getOnboardingRoles: [],
};

const onboardingSlice = createSlice({
  name: 'onboardingSlice',
  initialState,
  reducers: {
    getOnboardingSpecialtiesSlice: (state, { payload }) => {
      state.getOnboardingSpecialties = payload;
    },

    getOnboardingRolesSlice: (state, { payload }) => {
      state.getOnboardingRoles = payload;
    },
  },
});

const { actions, reducer } = onboardingSlice;

export const { getOnboardingSpecialtiesSlice, getOnboardingRolesSlice } =
  actions;

export default reducer;
